import { render, staticRenderFns } from "./LecturesProduction.vue?vue&type=template&id=77669a06&scoped=true"
import script from "./LecturesProduction.vue?vue&type=script&lang=js"
export * from "./LecturesProduction.vue?vue&type=script&lang=js"
import style0 from "./LecturesProduction.vue?vue&type=style&index=0&id=77669a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77669a06",
  null
  
)

export default component.exports